import React, { useState, useEffect, useRef } from "react";
import { Button, Pagination, Whisper, Tooltip } from "rsuite";
import { numberFormatter } from "../../utils";
import PlusRoundIcon from "@rsuite/icons/PlusRound";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@rsuite/icons/FileDownload";

const SupplierTable = (props: any) => {
	const { totalOpp, exportSupplierData } = props;
	const [limit, setLimit] = React.useState(10);
	const exportFullRef = useRef<any>(null);

	const exportExcel = () => {
		props?.getExportSupplierData();
	};

	useEffect(() => {
		if (exportSupplierData?.length !== 0) {
			exportFullRef?.current?.link.click();
		}
	}, [exportSupplierData]);

	const csvHeaders = [
		{ label: "Supplier", key: "master_vendor_name" },
		{ label: "Quantity", key: "LastYear_Qty" },
		{ label: "Spend", key: "LastYear_Cost" },
		{
			label: "Opportunity",
			key: `${
				props.target == "national"
					? "adjustedNationalOpportunity"
					: "adjustedRegionalOpportunity"
			}`,
		},
	];

	return (
		<>
			<div className="common-table-header-row">
				<span className="common-table-header">Supplier Table</span>
				<div className="buttonWrapper flex">
					<Button
						className="bg-transparent hover:bg-transparent"
						onClick={exportExcel}
					>
						<FileDownloadIcon
							color="black"
							className="text-fsre15"
						/>
					</Button>
					<CSVLink
						ref={exportFullRef}
						data={exportSupplierData}
						headers={csvHeaders}
						filename="costOptimisation_supplier.csv"
						className="hidden"
						target="_blank"
					>
						{" "}
					</CSVLink>
				</div>
			</div>
			<table className="common-table-ui w-[100%] !h-[80%]">
				<thead>
					<tr>
						<th style={{ width: "54%" }}>Supplier</th>
						<th style={{ width: "16%" }}>Quantity</th>
						<th style={{ width: "16%" }}>Spend</th>
						<th style={{ width: "20%" }}>
							Opportunity <br />
							<i className="text-[0.6vw] font-normal">
								(at 50% Capture Rate)
							</i>
						</th>
					</tr>
				</thead>
				<tbody>
					{Array.isArray(props.data) &&
						props?.data?.map((d: any, index: any) => {
							return (
								<tr
									key={d.master_vendor_name}
									onClick={() => {
										props?.updateSupplier(
											d.master_vendor_name
										);
									}}
								>
									<td>
										<PlusRoundIcon
											className="plusIcon"
											onClick={() => {
												props.updateSupplier(
													d.master_vendor_name
												);
											}}
										/>
										{
										// d.master_vendor_name.length > 25 ? 
										// <Whisper
										// 	placement="bottom"
										// 	speaker={
										// 		<Tooltip>
										// 			{ d.master_vendor_name}
										// 		</Tooltip>
										// 	}
										// >
										// 	{d.master_vendor_name.slice(0, 25) + "..." }

										// </Whisper>
										
										// : 
										d.master_vendor_name}
									</td>
									<td>
										{numberFormatter(d.LastYear_Qty, 0)}
									</td>
									<td>
										{numberFormatter(
											d.LastYear_Cost,
											0,
											"$"
										)}
									</td>
									<td>
										{props.target === "regional"
											? numberFormatter(
													d.adjustedRegionalOpportunity,
													0,
													"$"
											  )
											: numberFormatter(
													d.adjustedNationalOpportunity,
													0,
													"$"
											  )}
									</td>
								</tr>
							);
						})}
					<tr className="total-row bottom-[2.4vw]">
						<td className="center">Total</td>
						<td></td>
						<td></td>
						{/* {selectedItem && <td></td>}
            {selectedDistrict && <td></td>}
            {selectedGroup && (
              <>
                <td></td>
                <td></td>
              </>
            )} */}
						<td>
							{numberFormatter(
								props.target === "regional"
									? totalOpp?.regionalOpp
									: totalOpp?.nationalOpp,
								0,
								"$"
							)}
						</td>
					</tr>
				</tbody>
			</table>
			<div className="pagination-components h-[10%]">
				<Pagination
					prev
					next
					first
					last
					ellipsis
					boundaryLinks
					maxButtons={5}
					layout={["-", "pager", "skip"]}
					total={props.count}
					limit={limit}
					activePage={props.pageNumber}
					onChangePage={(e) => {
						props.updatePageNumber(e);
					}}
				/>
			</div>
		</>
	);
};
export default SupplierTable;
